import { useContext, useEffect, useState } from "react";
import KeycloakContext from "../../keycloakContext";
import { getFallbackVignette } from "../constants/vignetteCatalog";
import { getUserVignettes } from "../services/vignetteService";

export default function useSelectedVignetteAsset() {
  const keycloak = useContext(KeycloakContext);
  const fallback = getFallbackVignette();
  const [selectedVignette, setSelectedVignette] = useState(() => ({
    ...fallback,
    imagePath: localStorage.getItem("selectedVignettePath") || fallback.imagePath,
  }));

  useEffect(() => {
    const handleChange = (event) => {
      if (event.detail?.imagePath) {
        setSelectedVignette(event.detail);
      }
    };

    window.addEventListener("selectedVignetteChanged", handleChange);
    return () => window.removeEventListener("selectedVignetteChanged", handleChange);
  }, []);

  useEffect(() => {
    const userId = keycloak?.tokenParsed?.email || keycloak?.tokenParsed?.preferred_username;
    if (!keycloak?.authenticated || !userId) return;

    let cancelled = false;
    getUserVignettes(userId)
      .then((data) => {
        if (cancelled || !data?.selectedVignette) return;
        setSelectedVignette(data.selectedVignette);
        localStorage.setItem("selectedVignettePath", data.selectedVignette.imagePath);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [keycloak?.authenticated, keycloak?.tokenParsed?.email, keycloak?.tokenParsed?.preferred_username]);

  return {
    selectedVignette,
    selectedVignettePath: selectedVignette.imagePath || fallback.imagePath,
  };
}
